import { combineReducers, Reducer } from "redux";

import screenReducer from "./screen/slice";

const rootReducer: Reducer = combineReducers({
  screen: screenReducer,
});
export default rootReducer;
